import ApiService from '@/core/services/api.service';
import fileDownload from '@/utils/file-download';

export async function downloadDefectiveStockSlipDocument(stockSlipId, stockSlipCode = '') {
  const response = await ApiService.get(
    `v1/stock-slips/${stockSlipId}/export-defective-document`,
    { responseType: 'blob' },
  );

  let fileName;
  try {
    fileName = fileDownload.getFileName(response);
  } catch {
    fileName = `bien-ban-hang-loi-${stockSlipCode || stockSlipId}.xlsx`;
  }

  fileDownload.createFile(response.data, fileName);
  return fileName;
}
